module.exports = __webpack_public_path__ + "img/right-leg_hover.d3ee4444.png";